import React, { useState } from "react"
import { useSelector } from "react-redux"
import {
	Modal,
	ModalBody,
	ModalHeader,
	Button,
	ModalFooter,
	Input,
} from "reactstrap"
import { sendEvent } from "../../../api/socket/functions"
import styles from "../ScoreCounter.module.scss"

function TeamCommentModal({ team, teamComments }) {
	const [teamCommentModal, setTeamCommentModal] = useState(false)
	const [selectedComment, setSelectedComment] = useState()
	const [inputedComment, setInputedComment] = useState("")

	const { isMatchDone } = useSelector((state) => {
		return {
			isMatchDone:
				state.penaltiesOrEnd === "done" ||
				state.penaltiesOrEnd === "forfeit",
		}
	})

	const onDone = () => {
		const comment = selectedComment ?? inputedComment
		sendEvent({
			eventKey: "team comment",
			team: team.teamId,
			event: "Ekipni Komentar",
			comment,
		})
		dismissModal()
	}

	const dismissModal = () => {
		setTeamCommentModal(false)
		setSelectedComment()
		setInputedComment()
	}

	if (isMatchDone) {
		return <></>
	}

	return (
		<>
			<Button.Ripple
				color="flat-primary"
				onClick={() => setTeamCommentModal(true)}
			>
				Ekipni Komentar
			</Button.Ripple>
			<Modal
				isOpen={teamCommentModal}
				toggle={dismissModal}
				className="modal-dialog-centered"
			>
				<ModalHeader toggle={dismissModal}>
					Ekipni komentar za {team.name}
				</ModalHeader>
				<ModalBody>
					{!teamComments ? (
						<p>Upiši svoj komentar u polje ispod</p>
					) : inputedComment ? (
						<p>
							Ako želiš izabarti jedno od ponuđenih komentara, moraš
							prvo izbrisati sve iz kocke ispod
						</p>
					) : (
						<>
							<p>Izaberi jedan od ponuđenih komentara</p>
							<div className={styles.teamComments}>
								{teamComments.map((comment, index) => (
									<Button
										key={`teamComment-${index}`}
										outline={comment != selectedComment}
										color="primary"
										onClick={() => setSelectedComment(comment)}
									>
										{comment}
									</Button>
								))}
							</div>
							<hr />
							<p>Ili napravi svoj komentar</p>
						</>
					)}
					<Input
						type="text"
						onChange={({ target }) => {
							setInputedComment(target.value)
						}}
					/>
				</ModalBody>

				<ModalFooter>
					{selectedComment || inputedComment ? (
						<Button.Ripple color="primary" onClick={onDone}>
							Nastavi
						</Button.Ripple>
					) : (
						<></>
					)}
					<Button.Ripple color="secondary" outline onClick={dismissModal}>
						Odustani
					</Button.Ripple>
				</ModalFooter>
			</Modal>
		</>
	)
}

export default TeamCommentModal
